import { Icon, IconProps } from '@chakra-ui/react'

// Use namespace import to avoid Next.js react-icons barrel optimization errors on specific Fi* icons
import * as Fi from 'react-icons/fi'
import * as Lu from 'react-icons/lu'

// Re-export shims for @chakra-ui/icons compatibility during v2->v3 migration.
// Each icon accepts standard Chakra IconProps (color, boxSize, etc.) and renders via <Icon as={...} />.

export const AddIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiPlus />
  </Icon>
)
export const ChevronRightIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiChevronRight />
  </Icon>
)
export const ChevronLeftIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiChevronLeft />
  </Icon>
)
export const ChevronDownIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiChevronDown />
  </Icon>
)
export const ChevronUpIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiChevronUp />
  </Icon>
)
export const CloseIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiX />
  </Icon>
)
export const SmallCloseIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiX />
  </Icon>
)
export const CheckIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiCheck />
  </Icon>
)
export const CheckCircleIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiCheckCircle />
  </Icon>
)
export const ArrowBackIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiArrowLeft />
  </Icon>
)
export const ArrowForwardIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiArrowRight />
  </Icon>
)
export const ArrowLeftIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiArrowLeft />
  </Icon>
)
export const ArrowRightIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiArrowRight />
  </Icon>
)
export const ArrowDownIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiArrowDown />
  </Icon>
)
export const ArrowUpIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiArrowUp />
  </Icon>
)
export const ArrowUpDownIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Lu.LuArrowUpDown />
  </Icon>
)
export const CalendarIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiCalendar />
  </Icon>
)
export const DownloadIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiDownload />
  </Icon>
)
export const EditIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiEdit2 />
  </Icon>
)
export const DeleteIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiTrash2 />
  </Icon>
)
export const ExternalLinkIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiExternalLink />
  </Icon>
)
export const HamburgerIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiMenu />
  </Icon>
)
export const InfoIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiInfo />
  </Icon>
)
export const LockIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiLock />
  </Icon>
)
export const MinusIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiMinus />
  </Icon>
)
export const PhoneIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiPhone />
  </Icon>
)
export const PlusSquareIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiPlusSquare />
  </Icon>
)
export const QuestionIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiHelpCircle />
  </Icon>
)
export const SearchIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiSearch />
  </Icon>
)
export const SettingsIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiSettings />
  </Icon>
)
export const ViewIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiEye />
  </Icon>
)
export const ViewOffIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiEyeOff />
  </Icon>
)
export const WarningIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiAlertTriangle />
  </Icon>
)

// Re-export IconProps for any code that imported types from the old package
export type { IconProps }

// Some legacy code imported Icon directly from the icons package; re-export from Chakra for compat
export { Icon } from '@chakra-ui/react'

// Additional legacy @chakra-ui/icons names referenced in the codebase
export const AlertIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiAlertTriangle />
  </Icon>
)
export const ListIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiList />
  </Icon>
)
export const AccordionIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiChevronDown />
  </Icon>
)
export const StepIcon = (props: IconProps) => (
  <Icon {...props} asChild>
    <Fi.FiCheckCircle />
  </Icon>
)
